module.exports = { id: "bike", url: "/build/app/img/symbols.svg#bike", viewBox: "", toString: function() { return this.url; } };